import { ICourseNode } from "../datastructures/dataviz";
import { GenerateClassNameByAreas } from "../dataparsers/courseDataToNode";

export interface StyleByHeatmapAreaProps {
  area: number;
  CourseNodes: ICourseNode[];
}
export const StyleByHeatmapArea = (props: StyleByHeatmapAreaProps) => {
  let newCourseNodes: ICourseNode[] = [];
  //area -1 to return to normal
  if (props.area !== -1) {
    newCourseNodes = props.CourseNodes.map((node) => {
      // console.dir("hmap proc");
      // console.dir(node);
      if (node.data.courseCode === "APS380") {
        return node;
      }
      if (node.data.courseHeatmapAreas === null) node.stylemode = "heatmap-0";
      else
        node.stylemode =
          "heatmap-" + node.data.courseHeatmapAreas![props.area].relevance;
      return node;
    });
  } else {
    newCourseNodes = props.CourseNodes.map((node) => {
      node.stylemode = GenerateClassNameByAreas(node.data);
      return node;
    });
  }
  // console.log('ncn')
  // console.dir(newCourseNodes)
  return newCourseNodes;
};

export const ExpandAllCourseNodes = (props) => {
  //template for later
};
